import React from 'react';

export default function CrmChatDateSeparator({ label }) {
  return (
    <div className="flex justify-center my-4 animate-in fade-in duration-300">
      <span className="px-3 py-1 rounded-full bg-muted/80 text-[11px] font-medium text-muted-foreground shadow-sm">
        {label}
      </span>
    </div>
  );
}
